import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { SafeHTML } from '@thoughtspot/radiant-react/widgets/safe-html';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import _ from 'lodash';
import React, { useState } from 'react';
import { TranslationsKeys } from '../util';
import styles from './delete-confirmation-modal.module.scss';
const CONFIRM = 'CONFIRM';
const ONCHANGE_DELAY = 100;
export const DeleteConfirmationModal = ({ onDeleteConfirm, onDeleteModalClose, name, showLoader = false, isMultiSelected = false, }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [hasInputError, setHasInputError] = useState(false);
    const [confirmText, setConfirmText] = useState('');
    const onDismissModal = () => {
        setIsModalOpen(false);
        onDeleteModalClose();
    };
    const handleInputChange = _.debounce((event) => {
        const { value } = event.target;
        const text = value.toUpperCase();
        setConfirmText(text);
        setHasInputError(text !== CONFIRM);
    }, ONCHANGE_DELAY);
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: t(TranslationsKeys.CONFIRM_DELETE), isOpen: isModalOpen, className: styles.modalProps, confirmButton: {
            text: t(TranslationsKeys.DELETE),
            onConfirm: () => {
                if (CONFIRM === confirmText) {
                    onDeleteConfirm();
                }
                else {
                    setHasInputError(true);
                }
            },
            isLoading: showLoader,
            isDisabled: showLoader,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onDismissModal },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true, className: styles.modalBody },
            React.createElement(Alert.Banner, { message: React.createElement(SafeHTML, { html: isMultiSelected
                        ? t(TranslationsKeys.CONFIRM_DELETE_MSG_MULTIPLE)
                        : t(TranslationsKeys.CONFIRM_DELETE_MSG, {
                            itemName: name,
                        }) }), isVisible: true, showCloseButton: false, type: BannerAlertType.WARNING, className: styles.alertWarnBanner }),
            React.createElement("div", { "data-testid": "delete-confirmation-body" },
                React.createElement(Typography, { variant: "content-label-subhead", color: hasInputError ? Colors.failure : Colors.base, noMargin: true }, t(TranslationsKeys.CONFIRM_LABEL)),
                React.createElement(Input.Text, { ariaLabel: t(TranslationsKeys.CONFIRM_LABEL), value: confirmText, hasError: hasInputError, "data-testid": "confirmInput", onChange: handleInputChange })))));
};
//# sourceMappingURL=delete-confirmation-modal.js.map